<template>
    <div>
      <b-navbar variant="primary" type="dark">
        <b-navbar-brand href="/">
          <span id="brandText"><span class="fa fa-github" /> stats</span>
        </b-navbar-brand>
        <b-navbar-nav class="ml-auto">
          <b-nav-item @click="logout">Sign Out</b-nav-item>
        </b-navbar-nav>
      </b-navbar>
    </div>
  </template>
  
  <script>
  import {clearAuthTokens, retrieveAuthTokens} from "../common/authentication_utils"
  export default {
    data() {
        return {
            logoutURL:
                process.env.VUE_APP_COGNITO_LOGOUT_URL +
                window.location.origin +
                process.env.VUE_APP_LOGOUT_REDIRECT_PATH,
        };
    },
    methods: {
        logout() {
            clearAuthTokens();
            window.location.href=this.logoutURL
        },
    },
  };
  </script>
  
  <style lang="scss">
  #brandText {
    font-size: 1.5rem;
  }
  
  .navbar {
    padding-top: 2px;
    padding-bottom: 2px;
  }
  </style>